import React, { useContext } from "react";
import { FaDeviantart, FaEdit, FaEye, FaMedkit, FaRegStickyNote, FaTelegramPlane, FaTrash } from "react-icons/fa";
import TableReusable from "../../Global/Table";
import { SettingGeneralContext, SettingGeneralProvider } from "../../../context/settingGeneralContext";
import { render } from "@testing-library/react";
import { HiUser, HiUserGroup } from "react-icons/hi2";


export default function TablePatient({
  getData,
  formatToRupiah,
  rows,
  page,
  pages,
  changePage,
  msg,
  viewModalUpdate,
  deleteById,
  getDataPatientSsp,
  modalPhysicalCheck,
  modalDetailPatient,
  modalMedicalRecord,
  modalRepresentative,
  modalSatuSehat,
  soapPatient,
  odontogramPatient,
  getAppointmentSSP,
  updateUser,
  isTabletOrMobile
}) {
  return (
    <SettingGeneralProvider>
      <TablePatientContent
        getData={getData}
        formatToRupiah={formatToRupiah}
        rows={rows}
        page={page}
        pages={pages}
        changePage={changePage}
        msg={msg}
        viewModalUpdate={viewModalUpdate}
        deleteById={deleteById}
        getDataPatientSsp={getDataPatientSsp}
        modalPhysicalCheck={modalPhysicalCheck}
        modalDetailPatient={modalDetailPatient}
        modalMedicalRecord={modalMedicalRecord}
        modalRepresentative={modalRepresentative}
        modalSatuSehat={modalSatuSehat}
        soapPatient={soapPatient}
        odontogramPatient={odontogramPatient}
        getAppointmentSSP={getAppointmentSSP}
        updateUser={updateUser}
      />
    </SettingGeneralProvider>
  )
}

function TablePatientContent({
  getData,
  rows,
  page,
  pages,
  changePage,
  msg,
  viewModalUpdate,
  deleteById,
  getDataPatientSsp,
  modalPhysicalCheck,
  modalDetailPatient,
  modalMedicalRecord,
  modalRepresentative,
  modalSatuSehat,
  soapPatient,
  odontogramPatient,
  getAppointmentSSP,
  updateUser,
}) {

  const styles = {
    tableCell: {
      whiteSpace: "nowrap",
      padding: "8px",
    }
  };

  const getRowNumber = (index) => (page - 1) * 10 + index + 1;
  return (
    <>
      <div style={{ display: "block", height: "100%", overflowY: "auto", overflowX: "auto" }}>
        <TableReusable
          columns={[
            { key: "no", label: "No", render: (_, index) => getRowNumber(index) },
            { key: "fullname", label: "Nama Lengkap", render: (row) => `${row.first_name} ${row.last_name}` },
            { key: "gender", label: "Jenis Kelamin", render: (row) => row.gender === "male" ? "Laki-Laki" : row.gender === "female" ? "Perempuan" : row.gender },
            { key: "date_birth_id", label: "Tanggal Lahir" },
            { key: "age", label: "Usia", render: (row) => <span style={styles.tableCell}>{row.age} Tahun</span> },
            { key: "residence_address", label: "Alamat" },
            {
              key: "representative", label: "Perwakilan", render: (row) => (
                <>
                  {row.representatives.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {row.representatives?.map((rep, repIndex) => (
                        <>
                          <div
                            key={repIndex}
                            onClick={() => {
                              modalDetailPatient(rep?.patient?.id);
                            }}
                            style={{
                              display: "flex",
                              border: "none",
                              padding: "5px 10px",
                              cursor: "pointer",
                              borderRadius: "3px",
                              color: "white",
                              backgroundColor: rep?.representative?.patient_relation
                                ? rep?.representative?.patient_relation?.color
                                : "gray",
                              fontWeight: "bold",
                              width: "120px",
                              justifyContent: "center",
                              marginBottom: "5px",
                              height: "20px",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            <HiUser style={{ marginRight: "5px" }} />
                            {rep?.representative?.first_name} {rep?.representative?.last_name}
                          </div>
                        </>
                      ))}
                    </div>
                  )}
                </>
              )
            },
            {
              key: "data_medis", label: "Data Medis",
              render: (row) => (
                <>
                  <div className="mt-1" style={{ display: "flex", justifyContent: "center" }}>
                    <div
                      className="mt-1"
                      onClick={() => modalRepresentative(row?.id)}
                      style={{
                        display: "flex",
                        border: "none",
                        padding: "0px 7px",
                        cursor: "pointer",
                        borderRadius: "3px",
                        backgroundColor: "#A9B5DF",
                        color: "white",
                        fontWeight: "bold",
                        width: "120px",
                        justifyContent: "center"
                      }}>
                      <div style={{ display: "flex", alignItems: "center", marginRight: "5px" }}>
                        <HiUserGroup style={{}} />
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        Representative
                      </div>
                    </div>
                  </div>
                  <div className="mt-1" style={{ display: "flex", justifyContent: "center" }}>
                    <div
                      onClick={() => modalPhysicalCheck(row?.id)}
                      style={{
                        display: "flex",
                        border: "none",
                        padding: "0px 7px",
                        cursor: "pointer",
                        borderRadius: "3px",
                        backgroundColor: "#3D64FF", // warna biru untuk Physical Check
                        color: "white",
                        fontWeight: "bold",
                        width: "120px",
                        justifyContent: "center",
                        alignItems: "center"
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", marginRight: "5px" }}>
                        <FaMedkit />
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        Physical Check
                      </div>
                    </div>
                  </div>

                  <div className="mt-1" style={{ display: "flex", justifyContent: "center" }}>
                    <div
                      onClick={() => modalMedicalRecord(row?.id, row?.code)}
                      style={{
                        display: "flex",
                        border: "none",
                        padding: "0px 7px",
                        cursor: "pointer",
                        borderRadius: "3px",
                        backgroundColor: "#FF9090",
                        color: "white",
                        fontWeight: "bold",
                        width: "120px",
                        justifyContent: "center",
                        alignItems: "center"
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", marginRight: "5px" }}>
                        <FaMedkit />
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        Medical Record
                      </div>
                    </div>
                  </div>

                  <div className="mt-1" style={{ display: "flex", justifyContent: "center" }}>
                    <div onClick={() => soapPatient(row?.id, row?.first_name, row?.last_name)} style={{ display: "flex", border: "none", padding: "0px 7px", cursor: "pointer", borderRadius: "3px", backgroundColor: "#FFE84D", color: "white", fontWeight: "bold", width: "120px", justifyContent: "center" }}>
                      <div style={{ display: "flex", alignItems: "center", marginRight: "5px" }}>
                        <FaRegStickyNote style={{}} />
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        Soap Patient
                      </div>
                    </div>
                  </div>
                  <div className="mt-1" style={{ display: "flex", justifyContent: "center" }}>
                    <div onClick={() => odontogramPatient(row?.id, row?.first_name, row?.last_name)} style={{ display: "flex", border: "none", padding: "0px 7px", cursor: "pointer", borderRadius: "3px", backgroundColor: "#00EB8D", color: "white", fontWeight: "bold", width: "120px", justifyContent: "center" }}>
                      <div style={{ display: "flex", alignItems: "center", marginRight: "5px" }}>
                        <FaDeviantart style={{}} />
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        Odontogram
                      </div>
                    </div>
                  </div>
                  <div className="mt-1" style={{ display: "flex", justifyContent: "center", marginBottom: "5px" }} key={row.id}>
                    <div
                      onClick={() => modalSatuSehat(row?.id)}
                      style={{
                        display: "flex",
                        border: "none",
                        padding: "0px 7px",
                        cursor: "pointer",
                        borderRadius: "3px",
                        backgroundColor: "#98DED9",
                        color: "white",
                        fontWeight: "bold",
                        width: "120px",
                        justifyContent: "center",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", marginRight: "5px" }}>
                        <FaTelegramPlane />
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>Satu Sehat</div>
                    </div>
                  </div>
                  {/* 
                  {row?.satu_sehat_data !== false &&
                    (
                      <>
                        <div className="mt-1" style={{ display: "flex", justifyContent: "center", marginBottom: "5px" }} key={row.id}>
                          <div
                            onClick={() => modalSatuSehat(row?.id)}
                            style={{
                              display: "flex",
                              border: "none",
                              padding: "0px 7px",
                              cursor: "pointer",
                              borderRadius: "3px",
                              backgroundColor: "#98DED9",
                              color: "white",
                              fontWeight: "bold",
                              width: "120px",
                              justifyContent: "center",
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", marginRight: "5px" }}>
                              <FaTelegramPlane />
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>Satu Sehat</div>
                          </div>
                        </div>
                      </>

                    )
                  } */}
                </>
              )
            },
            {
              key: "action",
              label: "Setup",
              render: (row) => (
                <div style={{ display: "flex", flexDirection: "column", gap: "3px", justifyContent: "center", alignItems: "center", alignContent: "center" }}>
                  <button onClick={() => { modalDetailPatient(row?.id) }} style={{ fontSize: "12px", color: "white", backgroundColor: "#2c8efa", padding: "5px 5px", borderRadius: "3px", cursor: "pointer", border: "none", display: "flex" }}>
                    <FaEye />
                  </button>
                  <button onClick={() => { updateUser(row?.id) }} style={{ fontSize: "12px", color: "white", backgroundColor: "#ff9933", padding: "5px 5px", borderRadius: "3px", cursor: "pointer", border: "none", display: "flex" }}>
                    <FaEdit />
                  </button>
                  <button onClick={() => { deleteById(row?.id) }} style={{ fontSize: "12px", color: "white", backgroundColor: "#B60000", padding: "5px 5px", borderRadius: "3px", cursor: "pointer", border: "none", display: "flex" }}>
                    <FaTrash />
                  </button>
                </div>
              ),
            },
          ]}
          data={getData}
          rows={rows}
          page={page}
          pages={pages}
          changePage={changePage}
          msg={msg}
        />
      </div >
    </>
  )

}

